import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Landing from '../views/Landing.vue'
import Main from '../views/Main.vue'
import Configurator from '../views/Configurator.vue'
import Training from '../views/Training.vue'
import Inspirations from '../views/Inspirations.vue'
import Questions from '../views/Questions.vue'
import Glossary from '../views/Glossary.vue'
import Page from '../views/Page.vue'
import Blogpage from '../views/Blogpage.vue'
import Display from '../views/Display.vue'
import Survey from '../views/Survey.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Main,
    children: [
      {
        path: '',
        component: Home
      },
      {
        path: '/configurator',
        component: Configurator,
        props: true
      },
      {
        path: '/training',
        component: Training
      },
      {
        path: '/inspirations',
        component: Display,
        children: [
            {
                path: '',
                component: Inspirations
            },
            {
                path: ':inpage',
                component: Blogpage
            }
        ]
      },
      {
        path: '/questions',
        component: Questions
      },
      {
        path: '/glossary',
        component: Glossary
      },
      {
         path: '/survey',
         component: Survey,
         props: true
      },
      {
        path: '/:page',
        component: Page,
        meta: { reuse: false }
      }
    ]
  },
  {
    path: "*",
    component: Landing
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: function(to) {
    if(to.hash) {
      return {
        selector: to.hash,
        offset: {x:0, y:50}
      }
    }
  }
})

export default router
